import React, { useContext, useEffect, useState } from "react";
import educaCenso from "../../assets/img/logo1.png";
import logoCenso from "../../assets/img/logo-censo-branca.png";
import censo from "../../assets/img/censo.png";
import whatsapp from "../../assets/img/whatsapp.png";
import youtube from "../../assets/img/youtube.png";
import Input from "../../Components/input";
import Button from "../../Components/button";
import "./style.css";
import { useNavigate } from "react-router-dom";
import Public from "../../layout/public";
import api from "../../utils/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Loading from "../../Components/Loading";
import { Buffer } from "buffer";
import { authContext } from "../../context/auth";

const validationPost = yup.object().shape({
  inep: yup
    .number()
    .required("Informe o Inep da escola")
    .typeError("Informe o Inep da escola"),
});

function Login({ history }) {
  const [isLoading, setLoading] = useState(false);
  let navigate = useNavigate();
  const [inep, setInep] = useState();
  const [pathLogo, setPathLogo] = useState();
  const [infoApp, setInfoApp] = useState({});
  const { setAuth} = useContext(authContext)
  const [currentYear, setCurrentYear] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationPost),
  });

  const [userLog, setUserLog] = useState({
    code: "",
    idIEscolar: "",
    inepSchool: "",
    name: "",
    pathLogo: "",
  });

  function onSubmit() {
    setLoading(true);
    sessionStorage.setItem("inep", inep);
    sessionStorage.setItem("info-app", JSON.stringify(infoApp));
    api
      .post("/auth", userLog)
      .then((response) => {
        sessionStorage.setItem("censo", JSON.stringify(response.data));
        setAuth(true)
        setLoading(false);
        navigate("/Home");
      })
      .catch((erro) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
    let url = window.location.href;
    // url = new Buffer.from(url, 'base64').toString('ascii');
    let appInfo;

    if (
      url !== `${process.env.REACT_APP_URL_FRONT_CENSO}` &&
      url.includes("inep") &&
      url.includes("idcenso") &&
      url.includes("name")
    ) {
      let array = url.split("=");
      let inep = new Buffer.from(`${array[1]}=`, "base64").toString("ascii");
      let idCenso = array[3].replace(/([^\d])+/gim, "");
      let nome = array[4].replace("&path", "").split("%20");
      let completeName = "";
      let path =
        array[5] !== undefined
          ? new Buffer.from(`${array[5]}`, "base64").toString("ascii")
          : undefined;
      for (let k = 0; k < nome.length; k++) {
        completeName += nome[k] + " ";
      }
      let iniciais = nome[0][0] + "" + nome[nome.length - 1][0];
      let HomeLog = {
        iniciais,
        completeName,
        idCenso,
      };
      sessionStorage.setItem("HomeLog", JSON.stringify(HomeLog));
      setInep(inep);
      setPathLogo(path);
      setValue("inep", inep);
      setUserLog({
        iniciais: iniciais,
        idIEscolar: idCenso,
        inepSchool: inep,
        name: completeName,
      });
    }

    api.get("resource/app-info/").then((response) => {
      appInfo = {
        textInitial: response.data.textInitial,
        informationBoard: response.data.informationBoard,
        enableInfoBoard: response.data.enableInfoBoard,
        enableExportFile: response.data.enableExportFile,
        urlWhatsApp: response.data.urlWhatsApp,
        urlSiteCenso: response.data.urlSiteCenso,
        urlYouTube: response.data.urlYouTube,
      };
      setInfoApp(appInfo);
    });
  }, [setValue]);
  return (
    <>
      {isLoading && <Loading />}
      <Public>
        <div id="bloco-tudo">
          <div id="bloco-info">
            <div id="bloco-info-texto">
              <img
                id="educa-censo-logo"
                src={logoCenso}
                alt="logo"
              />
              <h1>SEJA BEM-VINDO!</h1>
              <div dangerouslySetInnerHTML={{ __html: infoApp.textInitial }} />
              <h6>REDES SOCIAIS</h6>
              <div id="bloco-redes-sociais">
                <a href={infoApp.urlSiteCenso} target="_blank" rel="noreferrer">
                  <img width={26} src={censo} alt="logo" />
                </a>
                <a href={infoApp.urlWhatsApp} target="_blank" rel="noreferrer">
                  <img width={27} src={whatsapp} alt="logo" />
                </a>
                <a href={infoApp.urlYouTube} target="_blank" rel="noreferrer">
                  <img width={35} src={youtube} alt="logo" />
                </a>
              </div>
            </div>
          </div>
          <div id="bloco-login">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div id="bloco-form">
                <div className="logo-city">
                  <img
                    id="educa-censo-logo-municipio"
                    src={
                      pathLogo !== null && pathLogo !== undefined
                        ? `${process.env.REACT_APP_PRE_LOGO}${pathLogo}${process.env.REACT_APP_POS_LOGO}`
                        : educaCenso
                    }
                    alt="logo"
                  />
                </div>
                <Input
                  name="inep"
                  type="number"
                  register={register("inep")}
                  placeholder={"Digite seu código"}
                  disabled
                  onChange={(e) => {
                    setInep(e.target.value);
                  }}
                />
                <Button title={"Confirmar"} type="submit" />
                <span id="message-erro">{errors.inep?.message}</span>
                {/* <img id='iescola-logo' src={Logo} /> */}
                <p>
                  {" "}
                  ©{currentYear} EducacensoiEscolar. Todos os direitos
                  reservados.
                </p>
              </div>
            </form>
          </div>
        </div>
      </Public>
    </>
  );
}
export default Login;
